import {KTIcon} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'

const JudolEditModalHeader = () => {
  const {setItemIdForUpdate, itemIdForUpdate} = useListView()

  return (
    <div className='modal-header' style={{padding: 12, height: 48}}>
      <h2 className='fw-bolder'>{itemIdForUpdate ? 'Edit' : 'Add'} Report Judi Online</h2>

      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-students-modal-action='close'
        onClick={() => setItemIdForUpdate(undefined)}
        style={{cursor: 'pointer'}}
      >
        <i className='fa-solid fa-xmark fs-2'></i>
      </div>
    </div>
  )
}

export {JudolEditModalHeader}
